import {
  useMemo,
  useState,
} from 'react';
import orderByActiveStatus from 'pages/Dashboard/utils/activeStatusOptions';

type ActiveStatus = {
  isActive?: boolean;
};

export default function useActiveStatusOptions<T extends ActiveStatus>(options: T[], type?: string) {
  const [showInactive, setShowInactive] = useState(false);
  const orderedOptions = useMemo(() => orderByActiveStatus(options), [options]);
  const activeOptions = useMemo(
    () => orderedOptions.filter((option) => option.isActive !== false),
    [orderedOptions],
  );
  const inactiveOptions = useMemo(
    () => orderedOptions.filter((option) => option.isActive === false),
    [orderedOptions],
  );
  const visibleOptions = showInactive ? orderedOptions : activeOptions;
  const inactiveConfig = inactiveOptions.length === 0 ? null : {
    showInactive,
    onToggleShowInactive: () => setShowInactive((current) => !current),
    type,
    count: inactiveOptions.length,
  };

  return {
    visibleOptions,
    inactiveConfig,
  };
}
